<template>
  <hm-content title="">
    <div slot="header">
      <hm-step
        :steps="steps"
        :step="step"
        disabledNext
        :scroll="true"
      ></hm-step>
    </div>
    <div v-if="step === 1">
      <div class="table-panel flex flex-between">
        <div>
          <el-button type="primary" size="small" @click="dialogVisible = true"
            >添加商品</el-button
          >
        </div>
        <div>
          <el-input
            clearable
            style="width: 200px"
            v-model.trim="filterText"
            @input="filterList('Result')"
            placeholder="请输入货号/商品名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="filterList('Result')"
            >查询</el-button
          >
        </div>
      </div>
      <div class="flex flex-end mb10">
        <div @click="batchSetting" class="pointer mr20">
          <span class="delete-icon hmicon icon-xitong"></span>
          批量设置
        </div>
        <div @click="batchDel" class="pointer">
          <span class="delete-icon hmicon icon-shanchu"></span>
          批量删除
        </div>
      </div>
      <div class="listResult">
        <el-form
          :rules="model.rules"
          :model="model"
          ref="ruleForm"
          label-width="0px"
        >
          <el-table
            stripe
            border
            ref="btable"
            :data="model.listResult"
            @selection-change="getChecked"
            style="width: 100%"
            id="table"
            size="small"
            max-height="500"
          >
            <el-table-column type="selection"></el-table-column>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spuName"
              label="商品名称"
              width="280"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="brandName"
              label="品牌名称"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="specBarcode"
              show-overflow-tooltip
              label="商品条码"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsSn"
              show-overflow-tooltip
              label="商品货号"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="specIdGroupName"
              label="规格"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="left"
              prop="spuName"
              label="单品复购周期（取整数部分）"
            >
              <template slot="header">

                  单品复购周期（取整数部分）
                  <el-tooltip
                    class="tooltip"
                    effect="light"
                    content="单品的使用周期，取整数部分"
                    placement="top"
                  >
                    <i class="el-icon-question" style="font-size: 18px"></i>
                  </el-tooltip>
    
              </template>
              <template slot-scope="scope">
                <el-form-item
                  class="from-err"
                  :prop="'listResult.' + scope.$index + '.repurchaseCycleNum'"
                  :rules="model.rules.repurchaseCycleNum"
                >
                  <el-input
                    clearable
                    style="width: 100px"
                    v-model.trim="scope.row.repurchaseCycleNum"
                    size="small"
                    @mousewheel.prevent.native
                    @input="filterGt0OrFixed0('repurchaseCycleNum', scope.$index)"
                    class="ipt mr10 ratioipt"
                  >
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>

            <el-table-column
              header-align="center"
              align="center"
              label="操作"
              width="200"
            >
              <template slot-scope="scope">
                <el-button
                  size="small"
                  class="danger"
                  type="text"
                  @click="del(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <div class="btn-wrapper text-center mt10">
          <el-button type="primary" size="small" @click="next('ruleForm')"
            >下一步</el-button
          >
          <el-button size="small" type="info" @click="$router.back(-1)"
            >返 回</el-button
          >
        </div>
      </div>
    </div>
    <div v-else class="flex flex-center" style="margin-top: 100px">
      <div class="text-center">
        <div class="flex flex-center">
          <div class="yuan">
            <span style="font-size: 20px" class="hmicon icon-duigou"></span>
          </div>
        </div>
        <div class="success" style="font-size: 20px; line-height: 40px">
          复购周期设置完成
        </div>
        <!-- <div style="font-size: 16px">
          共有 <span class="blue">232</span> 个商品成功设置复购周期
        </div> -->
        <div class="btn-wrapper text-center mt20">
          <el-button type="primary" size="small" @click="goOn"
            >继续批量设置</el-button
          >
          <el-button size="small" @click="back">返回列表</el-button>
        </div>
      </div>
    </div>
    <hm-select-all-goods
        ref="allgoods"
      :visible="dialogVisible"
      :enabelList="model.listResult"
      @close="dialogVisible = false"
      @saveGoods="saveGoods"
    >
    </hm-select-all-goods>
    <hm-batch-purchase-cycle
      :visible="dialogVisibleBatch"
      @close="dialogVisibleBatch = false"
      @confirm="confirm"
      title="批量编辑复购周期"
    >
    </hm-batch-purchase-cycle>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
import HmSelectAllGoods from "@/components/HmSelectAllGoods";
import HmBatchPurchaseCycle from "@/components/HmBatchPurchaseCycle";

import { arrayUnique2 } from "@/utils/utils";
export default {
  components: { HmStep, HmSelectAllGoods, HmBatchPurchaseCycle },
  data() {
    return {
      dialogVisibleBatch: false,
      enabelList: [],
      dialogVisible: false,
      step: 1,
      model: {
        rules: {
          repurchaseCycleNum: [
            {
              required: true,
              message: "必填字段",
              trigger: "change"
            }
          ]
        },
        list: [],
        listResult: []
      },

      filterText: "",
      steps: [
        {
          link: "BatchSettingPurchaseGoods",
          name: "选择商品"
        },
        {
          link: "BatchSettingPurchaseGoods",
          name: "设置完成"
        }
      ],
      checkedRowList: []
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    confirm(val) {
      this.model.listResult.forEach(v => {
        if (this.checkedRowList.findIndex(o => o.skuId === v.skuId) >= 0) {
          this.$set(v, "repurchaseCycleNum", val);
        }
      });
      this.$forceUpdate();
      this.dialogVisibleBatch = false;
    },
    filterGt0OrFixed0(prop, i) {
      this.model.listResult[i][prop] = this.model.listResult[i][prop].replace(
        /^(0+)/,
        ""
      ); //过滤0开头
      this.model.listResult[i][prop] = this.model.listResult[i][prop].replace(
        /^(0+)|[^\d]+/g,
        ""
      );
      this.model.listResult[i][prop] = this.model.listResult[i][prop].replace(
        /\.{2,}/g,
        ""
      ); //两个连续的"."仅保留第一个"."
    },
    saveGoods(checkedRowList) {
      checkedRowList.forEach(v => {
        this.$set(v, "repurchaseCycleNum", "");
        // v.repurchaseCycleNum = "";
      });
      this.model.listResult.push(...checkedRowList);
      this.model.listResult = arrayUnique2(this.model.listResult, "skuId");
      this.model.list.push(...checkedRowList);
      this.model.list = arrayUnique2(this.model.list, "skuId");
      this.dialogVisible = false;
      this.$refs.btable.toggleAllSelection();
    },
    back() {
      this.$router.push({
        name: "PurchaseCycle"
      });
    },
    goOn() {
      this.model.listResult = [];
      this.model.list = [];
      this.step = 1;
      this.filterText = "";
      this.$refs.allgoods.queryList();
    },
    batchSetting() {
      if (this.checkedRowList.length) {
        this.dialogVisibleBatch = true;
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    batchDel() {
      if (this.checkedRowList.length) {
        this.$confirm("删除所有选中的结果？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.model.list = this.model.list.filter(
            v =>
              !this.checkedRowList.some(
                item => String(v.skuId) === String(item.skuId)
              )
          );
          this.model.listResult = this.model.list;
          this.checkedRowList = [];
          this.$message({
            message: "操作成功！",
            type: "success"
          });
        });
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    getChecked(selection) {
      this.checkedRowList = selection;
    },
    next(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let repurchaseSkuInfoModels = this.model.listResult;
          this.$store
            .dispatch("batchSaveRepurchaseSku", { repurchaseSkuInfoModels })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功！",
                  type: "success"
                });
                this.step = 2;
              }
            });
        }
      });
    },
    filterList(originData) {
      this.model["list" + originData] = this.model.list.filter(v => {
        return (
          v.goodsSn.indexOf(this.filterText) > -1 ||
          v.spuName.indexOf(this.filterText) > -1
        );
      });
    },
    del(i) {
      this.model.listResult.splice(i, 1);
      this.model.list.splice(i, 1);
    },
    addGoods() {}
  }
};
</script>
<style lang="scss">
.listResult {
  .from-err {
    .el-form-item__error {
      top: 10px;
      left: 160px;
    }
    & {
      margin-bottom: 0px;
    }
  }
}
</style>
<style lang='scss' scoped>
.yuan {
  width: 55px;
  height: 55px;
  border-radius: 50%;
  background: #2fc348;
  .icon-duigou {
    line-height: 55px;
    text-align: center;
    color: #fff;
  }
}
</style>
